<div class="texto" *ngIf="!requiredValidation">
  Turnos reservados para el día de hoy:
</div>

<div class="texto" *ngIf="requiredValidation">
   Validación de datos:
</div>

<div *ngIf="!requiredValidation" class="appointment-container">
  <div class="appointment-panel" *ngFor="let appt of appointments">
    <p><strong>Fecha:</strong> {{ appt.Date | date : "dd/MM/yyyy HH:mm" }}</p>
    <p><strong>Procedimiento:</strong> {{ appt.Procedure }}</p>
    <p><strong>Centro:</strong> {{ appt.Center }}</p>
    <p><strong>Servicio:</strong> {{ appt.Service }}</p>
  </div>
</div>

<div *ngIf="requiredValidation" class="validation-container">
  <mat-form-field *ngIf="requiredCredential" class="credential-text">
    <input
      [(ngModel)]="credential"
      style="width: 100%"
      placeholder="Número de afiliado"
      type="text"
      autocomplete="off"
      matInput
    />
  </mat-form-field>
  <mat-form-field *ngIf="requiredSecurityCode" class="codigo-text">
    <input
      [(ngModel)]="securityCode"
      style="width: 100%"
      placeholder="Cód. de seguridad"
      type="text"
      autocomplete="off"
      matInput
    />
  </mat-form-field>
  <mat-form-field *ngIf="requiredPreAuth" class="preautorizacion-text">
    <input
      [(ngModel)]="preAuth"
      style="width: 100%"
      placeholder="Pre autorización"
      type="text"
      autocomplete="off"
      matInput
    />
  </mat-form-field>
</div>

<p style="text-align: right; margin-right: 5px">
  <mat-spinner *ngIf="loadingAction"></mat-spinner>
  <button
    *ngIf="!requiredValidation"
    (click)="next()"
    class="next-button"
    mat-stroked-button
    color="primary"
    [disabled]="loadingAction"
  >
    Siguiente
  </button>
  <button
    *ngIf="requiredValidation"
    (click)="nextValidate()"
    class="next-button"
    mat-stroked-button
    color="primary"
    [disabled]="loadingAction"
  >
    Siguiente
  </button>
  <button
    *ngIf="requiredValidation"
    (click)="nextRequiredAsisst()"
    class="next-button"
    mat-stroked-button
    color="primary"
    [disabled]="loadingAction"
  >
    Recepción asistida
  </button>
</p>
